import React, { memo } from 'react'
import {
  View,
  ImageBackground,
  TouchableOpacity,
} from 'react-native'
import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import { Icon } from '@vfgroup-oneplatform/foundation/Components'
import PropTypes from 'prop-types'

import VfText from '../VfText'

import Images from '../../Themes/Images'
import styles from './RecommendedCard.Styles'

function RecommendedCard({
  name,
  label,
  price,
  duration,
  image,
  images,
  cta,
  onPress,
}) {

  const theme = useTheme()

  return (
    <View style={styles.container(theme)}>
      <TouchableOpacity style={styles.touchable} onPress={() => onPress()} activeOpacity={0.5} >
        <ImageBackground source={images[image]} style={styles.image}>
          {Boolean(label) && <VfText
            i18nKey={label}
            size="footnote"
            color={Colors.thinDark}
            style={styles.label}
            numberOfLines={1}
          />}
          {/* <TouchableOpacity style={styles.starContainer}>
            <Icon name={Images.ic_slider_thumb} type="image" size={20} resizeMode="contain" />
          </TouchableOpacity>
          <TouchableOpacity style={styles.partnerContainer}>
            <Icon name={Images.slack_logo} type="image" size={32} resizeMode="contain" />
          </TouchableOpacity> */}
        </ImageBackground>
        <View style={styles.details}>
          <VfText i18nKey={name} weight="bold" color={theme.colors.textColorThree} numberOfLines={2} />
          <View style={styles.action}>
            <VfText i18nKey={cta} size="footnote" color={theme.colors.textColorTwo} />
            <Icon name={Images.ic_chevron_right_red} type="image" size={18} resizeMode="contain" />
          </View>
        </View>
      </TouchableOpacity>
    </View>
  )
}

RecommendedCard.defaultProps = {
  image: 'image',
  images: { image: Images.card },
  onPress: () => { },
}

RecommendedCard.propTypes = {
  image: PropTypes.string,
  images: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  duration: PropTypes.string,
  cta: PropTypes.string,
  onPress: PropTypes.func,
}

export default memo(RecommendedCard)
